import React from 'react'

import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import TwitterIcon from '@mui/icons-material/Twitter'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import AppleIcon from '@mui/icons-material/Apple'
import AndroidIcon from '@mui/icons-material/Android'

const social = [
  {
    type: 'facebook',
    link: '//facebook.com/abillionapp',
    title: 'Follow us on Facebook',
    icon: <FacebookIcon fontSize="inherit" />
  },
  {
    type: 'instagram',
    link: '//instagram.com/abillion',
    title: 'Follow us on Instagram',
    icon: <InstagramIcon fontSize="inherit" />
  },
  {
    type: 'twitter',
    link: '//twitter.com/abillionapp',
    title: 'Follow us on Twitter',
    icon: <TwitterIcon fontSize="inherit" />
  },
  {
    type: 'linkedin',
    link: 'https://www.linkedin.com/company/abillion',
    title: 'Follow us on LinkedIn',
    icon: <LinkedInIcon fontSize="inherit" />
  },
  {
    type: 'apple',
    link: '//apps.apple.com/us/app/abillionveg/id1377119949?mt=8',
    title: 'Find us on the App Store',
    icon: <AppleIcon fontSize="inherit" />
  },
  {
    type: 'google',
    link: '//play.google.com/store/apps/details?id=com.abvmobile',
    title: 'Find us on Google Play',
    icon: <AndroidIcon fontSize="inherit" />
  }
]

export default social
